import axios from 'axios'
/* const mocks = {
  'auth': { 'POST': { token: 'This-is-a-mocked-token' } },
  'user/me': { 'GET': { name: 'doggo', title: 'sir' } }
} */

const apiCall = ({url, method, ...args}) => new Promise((resolve, reject) => {
  if (method === 'POST') {
    axios.post(url, args).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error.response)
    })
  } else if (method === 'PUT') {
    axios.put(url, args).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error.response)
    })
  } else if (method === 'GET') {
    axios.get(url, args).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error.response)
    })
  }
  /* setTimeout(() => {
    try {
      resolve(mocks[url][method || 'GET'])
      console.log(`Mocked '${url}' - ${method || 'GET'}`)
      console.log('response: ', mocks[url][method || 'GET'])
    } catch (err) {
      reject(new Error(err))
    }
  }, 1000) */
})

export default apiCall



// WEBPACK FOOTER //
// ./src/utils/api.js